"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getErrorMessage(errorApi, errorJS) {
    var _a, _b;
    if (errorApi) {
        return (errorApi === null || errorApi === void 0 ? void 0 : errorApi.statusText);
    }
    if (errorJS) {
        return ((_b = (_a = errorJS.error) === null || _a === void 0 ? void 0 : _a.message.toString()) !== null && _b !== void 0 ? _b : errorJS.event.toString());
    }
    return ('');
}
exports.getErrorMessage = getErrorMessage;
function getErrorCode(errorApi, errorJS) {
    if (errorApi) {
        return (errorApi === null || errorApi === void 0 ? void 0 : errorApi.status.toString());
    }
    if (errorJS) {
        return (errorJS.event.toString());
    }
    return ('');
}
exports.getErrorCode = getErrorCode;
function getErrorDetails(errorApi, errorJS) {
    var _a, _b, _c;
    if (errorApi) {
        return ((errorApi === null || errorApi === void 0 ? void 0 : errorApi.data) ? JSON.stringify(errorApi === null || errorApi === void 0 ? void 0 : errorApi.data) : '');
    }
    if (errorJS) {
        return ("" + (errorJS.source ? "[" + errorJS.source + "] " : '') + (errorJS.lineno ? "line: " + errorJS.lineno + " " : '') + (errorJS.colno ? "col: " + errorJS.colno + " " : '') + (((_a = errorJS.error) === null || _a === void 0 ? void 0 : _a.name) ? "[" + ((_b = errorJS.error) === null || _b === void 0 ? void 0 : _b.name) + "]" : '') + " " + ((_c = errorJS.error) === null || _c === void 0 ? void 0 : _c.message));
    }
    return ('');
}
exports.getErrorDetails = getErrorDetails;
//# sourceMappingURL=ErrorExtractInformation.js.map